export default __webpack_public_path__ + "static/media/mobile_logo.51d81edc.svg";